"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxGroup = exports.checkbox = void 0;

var _size = _interopRequireDefault(require("../choices/size.const"));

var _color = _interopRequireDefault(require("../choices/color.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var checkbox = {
  accentColor: _color["default"].cloudyBlue,
  backgroundColor: _color["default"].white,
  checkboxBorder: _size["default"].borderSizeDefault,
  checkboxBorderRadius: _size["default"].borderRadiusSmall,
  checkboxDashHeight: _size["default"].smallest,
  checkboxDashWidth: _size["default"]["default"],
  checkboxIconFillColor: _color["default"].white,
  checkboxMargin: _size["default"]["default"],
  checkboxSize: _size["default"].default2x,
  checkedBackgroundColor: _color["default"].dodgerBlue,
  labelColor: _color["default"].pickledBluewood800,
  labelHeight: _size["default"].medium
};
exports.checkbox = checkbox;
var checkboxGroup = {
  verticalGroupMargin: _size["default"]["default"],
  horizontalGroupMargin: _size["default"].default2x
};
exports.checkboxGroup = checkboxGroup;